module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.msgText.length > 0) ? _c('v-card', {
    staticClass: "carte",
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.msgText))])])], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick()
      }
    }
  }, [_vm._v("OK")])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0f0bd82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/AcceptInvitation.vue
// module id = 1219
// module chunks = 1